/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
/* eslint-disable */
import { FormRecordProcessOrderStockOuttakeCheckFieldComponent } from '../../admin/form/form-record/fields/process-order-stock-outtake-check/form-record-process-order-stock-outtake-check-field.component';
/* eslint-enable */

/* eslint-enable */

export class FormRecordProcessOrderStockOuttakeCheckFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordProcessOrderStockOuttakeCheckFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
